import React from 'react'

import { AcornsIcon, Icon } from '@acorns/icons'
import { A4_ActionStrip } from '@acorns/web-components'
import styled from 'styled-components'

import { style } from 'theme'

type Props = {
  title?: string
  handleBackPress?: () => void
  subTitle?: string
  handleAboutPress?: () => void
  handleCancelPress?: () => void
  aboutIcon?: Icon
  closeButton?: Icon
  handleClosePress?: () => void
  backgroundColor?: string
  backOverride?: string
  showBackButton?: boolean
}

const StyledButton = styled.button`
  border: none;
  background: none;
`
const CancelButton = styled.button`
  border: none;
  background: none;
  font-size: 12px;
  font-weight: 600;
  line-height: 22px;
  color: ${style((theme) => theme.colors.stone)};
`

export const ActionStripMobile: React.FC<Props> = (props) => {
  const actionButton = () =>
    props.handleAboutPress ? (
      <StyledButton aria-label="Learn More" onClick={props.handleAboutPress}>
        <AcornsIcon
          icon={props.aboutIcon ?? AcornsIcon.Icon.QuestionMark}
          height="20px"
          width="20px"
        />
      </StyledButton>
    ) : props.handleCancelPress ? (
      <CancelButton onClick={props.handleCancelPress}>Cancel</CancelButton>
    ) : (
      <div />
    )
  return (
    <A4_ActionStrip
      backOverride={props.backOverride}
      showBack={props.showBackButton ?? true}
      backIcon={
        props.closeButton ? (
          <StyledButton
            aria-label="Close Button"
            onClick={props.handleClosePress ?? props.handleBackPress}
          >
            <AcornsIcon icon={props.closeButton} height="16px" width="16px" />
          </StyledButton>
        ) : (
          <StyledButton
            aria-label="Back Button"
            onClick={props.handleBackPress}
          >
            <AcornsIcon
              icon={AcornsIcon.Icon.ArrowLeft}
              height="12px"
              width="16px"
            />
          </StyledButton>
        )
      }
      title={props.title}
      verticalSubText
      subtext={props.subTitle}
      showMobileActions
    >
      {actionButton()}
    </A4_ActionStrip>
  )
}
